// <div data-controller="workorders--form--materials">
//   <h1 data-target="workorders--form--materials.output"></h1>
//   <h1 data-target="workorders--form--materials#action"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "site", "materials" ]

  connect() {
    this.fetchParams = {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    }
    this.fetchUrl = this.data.get("route")
    this._fetchIfSiteSelected()
  }

  siteChange() {
    const siteId = this._siteId()
    if (siteId) {
      this._fetchMaterials(siteId)
      return
    }

    const tasks = document.getElementById("maintenance-tasks")
    if (tasks) tasks.innerHTML = ""
  }

  _fetchIfSiteSelected() {
    if (this.data.get("workorderId")) return

    const siteId = this._siteId()
    if (!siteId) return
    this._fetchMaterials(siteId)
  }

  _fetchMaterials(siteId) {
    fetch(this.fetchUrl + `?id=${siteId}`, this.fetchParams)
      .then(response => response.text())
      .then(str => eval(str))
      .catch(() => alert('Oops, there was an error'))
  }

  _siteId() {
    if (this.hasSiteTarget) {
      if (this.siteTarget.tagName === "SELECT") {
        return this.siteTarget.value
      }
      const dataSiteId = this.siteTarget.dataset.siteId
      if (dataSiteId) return dataSiteId
    }

    const hiddenSite = this.element.querySelector("input[type='hidden'][name='workorder[site_id]']")
    return hiddenSite ? hiddenSite.value : ''
  }
}
